import React, { useEffect, useState } from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";
import { getCurrentUser } from "./app/common/routines/user-operations";
import { routes } from "./app/constants/routes";
import AppRoute from "./app-route";
import Login from "./app/features/login/login";
import ForgotPassword from "./app/features/forgot-password/forgot-password";
import TenetList from "./app/features/tenant/tenant-list/tenant-list";
import MainLayout from "./app/features/home/main-layout/main-layout";
import Dashboard from "./app/features/dashboard/dashboard";
import LeadList from "./app/features/leads/lead-list";
import UserManagementList from "./app/features/user-management/user-management-list/user-management-list";
import UserManagementRole from "./app/features/user-management/user-management-role/user-management-role";
import CreateLead from "./app/features/leads/create-lead/create-lead";
import LeadQualification from "./app/features/lead-qualification/lead-qualification-lead-list";
import Requests from "./app/features/tenant/requests/tenent-requests";
import TermsOfService from "./app/features/terms-of-services/terms-of-services";
import Profile from "./app/features/profile/edit-profile";
import ResetPassword from "./app/features/reset-password/reset-password";
import Unauthorized from "./app/common/components/un-authorized/un-authorized";
import ProtectedRoute from "./app/protected-route";
import MODULES from "./app/constants/modules";
import PersonalSettings from "./app/features/settings/personal-settings";
import SocialImport from "./app/features/leads/import-leads/social-import";
import CompnaySettings from "./app/features/settings/company-settings";
import { applyCSSVariables } from "./app/utils/themeUtils";
import CreateCampaign from "./app/features/campaign/create-campaign/create-campaign";
import CampaignList from "./app/features/campaign/campaign-list/campaign-list";
import TenantDetails from "./app/features/tenant/tenant-details/tanant-details";
import ChangePlan from "./app/features/tenant/tenant-details/tenant-details-right-panel/tenant-plan-details/change-plan";
import Myplans from "./app/features/settings/my-plans/my-plans";
import UserChangePlan from "./app/features/settings/my-plans/user-change-plan/user-change-plan";
import LeadCaptureFormList from "./app/features/lead-capture/lead-capture-form-list";
import UnAssignedLeads from "./app/features/leads/lead-assignment/un-assigned-leads";
import AssignmentRules from "./app/features/leads/lead-assignment/assignement-rules";
import Leads from "./app/features/leads/lead-assignment/assignement-rules/leads";
import CreateAssignmentRule from "./app/features/leads/lead-assignment/assignement-rules/create-rule";
import ApprovedLeads from "./app/features/leads/lead-assignment/un-assigned-leads/approved-leads";
import CreateNewPlan from "./app/features/tenant/crm-plans/create-new-plan/create-new-plan";
import CRMPaidPlans from "./app/features/tenant/crm-plans/crm-paid-plans/crm-paid-plans";
import CrmNoCostPlans from "./app/features/tenant/crm-plans/crm-no-cost-plans/crm-no-cost-plans";
import CrmTrailPlans from "./app/features/tenant/crm-plans/crm-trail-plans/crm-trail-plans";
import UserTermsOfService from "./app/features/user-management/user-terms-of-services/user-terms-of-services";
import ArchivedRules from "./app/features/leads/lead-assignment/assignement-rules/achieved-rules-list";
import LeadsLog from "./app/features/tenant/leads-log/leads-log";
import ContactUs from "./app/features/contact-us/contact-us";
import LeadLogs from "./app/features/leads/lead-logs/leads-log";
import RequestAccess from "./app/features/request-access/request-access";
import UserRequests from "./app/features/user-management/user-requests/user-requests";
import Orders from "./app/features/payments/order-management/orders/orders";
import InvoicesList from "./app/features/payments/order-management/invoices/invoices-list";
import ViewSurveys from "./app/features/surveys/view-surveys/view-surveys-form-list";
import CreateSurveys from "./app/features/surveys/create-surveys/create-surveys";
import CampaignPerformanceMetrics from "./app/features/campaign/campaign-performance-metrics/campaign-performance-metrics";
import OrderDetailChangePlan from "./app/features/payments/order-management/orders/order-details/change-plan/change-plan";
import CustomerList from "./app/features/customer/customer-list";
import CustomerEngagement from "./app/features/customer/customer-engagement/customer-engagement";
import CustomerSupport from "./app/features/customer/customer-support/customer-support";
import UserReports from "./app/features/user-management/user-reports/user-reports";
import LeadReports from "./app/features/leads/lead-reports/lead-reports";
import SubscriptionReport from "./app/features/payments/subscription-report/subscription-report";
import CampaignLandingPage from "./app/features/campaign/landing-page/landing-page";
import OrderDetail from "./app/features/payments/order-management/orders/order-details/order-detail";
// import EmailTemplateList from "./app/features/surveys/email-templates/email-template-list";
import EmailTemplateTabs from "./app/features/surveys/email-templates/email-templates-tabs";
import LetterTemplatesList from "./app/features/surveys/letter-templates/letter-templates-list";
import QRCodeList from "./app/features/surveys/qr-code/qr-code-list";
import UnsubscribeConfirmation from "./app/features/unsubscribe-confirmation/UnsubscribeConfirmation";
import UnsubscribedUsersList from "./app/features/surveys/unsubscribed-users-list";
import TrackUploads from "./app/features/settings/track-uploads/track-uploads";
import CustomerSocialImport from "./app/features/customer/import-customers/social-import";
import SupportTicketTabs from "./app/features/afp-support/support-ticket-tabs";
import Guides from "./app/features/guides/guides";
import CustomPlans from "./app/features/tenant/crm-plans/crm-custom-plans/crm-custom-plans";
import NotesList from "./app/features/surveys/notes-list/notes-list";
import LeadView from "./app/features/leads/lead-view/lead-view";
import LeadCapturedFormLeadList from "./app/features/lead-capture/lead-captured-form-lead-list/lead-captured-form-lead-list";
import CustomerView from "./app/features/customer/customer-view/customer-view";
import CampaignView from "./app/features/campaign/campiagn-view/campaign-view";

const mstp = (state: any) => {
  return {
    isLoggedIn: state.session.isLoggedIn,
    appDataLoading: state.appearance.appDataLoading,
    tenantDetails: state.session.tenantDetails,
    userDetails: state.session.userDetails,
  };
};

const mdtp = (dispatch: any) => {
  return {
    setLoggedIn: (value: any, userDetails: any) => {
      dispatch({
        type: "SESSION:SET_IS_LOGGED_IN",
        payload: { value, userDetails },
      });
    },
  };
};

function App(props: any) {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route>
        {props.isLoggedIn || props.loggedIn ? (
          <>
            <Route path={routes.HOME} element={<MainLayout />}>
              <Route path={routes.DASHBOARD} element={<Dashboard />} />

              {/* Partner-management routes */}
              <Route
                path={routes.REQUESTS}
                element={
                  <ProtectedRoute moduleName={MODULES.PARTNER_REQUESTS}>
                    <Requests />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.PARTNERLIST}
                element={
                  <ProtectedRoute moduleName={MODULES.PARTNER_LIST}>
                    <TenetList />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.PARTNERDETAILS}
                element={
                  <ProtectedRoute moduleName={MODULES.PARTNER_LIST}>
                    <TenantDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.PARTNERLEADSLOG}
                element={
                  <ProtectedRoute moduleName={MODULES.PARTNER_LIST}>
                    <LeadsLog />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.PARTNER_DETAILS_CHANGE_PLAN}
                element={
                  <ProtectedRoute moduleName={MODULES.PARTNER_LIST}>
                    <ChangePlan />
                  </ProtectedRoute>
                }
              />
              {/* <Route
                path={routes.CREATE_PLAN}
                element={
                  <ProtectedRoute moduleName={MODULES.TENANT_MANAGEMENT}>
                    <TenetList />
                  </ProtectedRoute>
                }
              /> */}

              {/* CRM PLANS */}
              <Route
                path={routes.CREATE_CRM_PLAN}
                element={
                  <ProtectedRoute moduleName={MODULES.PARTNER_CRM_PLANS}>
                    <CreateNewPlan />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.CRM_PAID_PLANS}
                element={
                  <ProtectedRoute moduleName={MODULES.PARTNER_CRM_PLANS}>
                    <CRMPaidPlans />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.CRM_NO_COST_PLAN}
                element={
                  <ProtectedRoute moduleName={MODULES.PARTNER_CRM_PLANS}>
                    <CrmNoCostPlans />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.CRM_TRIAL_PLANS}
                element={
                  <ProtectedRoute moduleName={MODULES.PARTNER_CRM_PLANS}>
                    <CrmTrailPlans />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.CRM_CUSTOM_PLANS}
                element={
                  <ProtectedRoute moduleName={MODULES.PARTNER_CRM_PLANS}>
                    <CustomPlans />
                  </ProtectedRoute>
                }
              />

              {/* Lead-management routes */}
              <Route
                path={routes.LEADCAPTUREFORM}
                element={
                  <ProtectedRoute moduleName={MODULES.LEAD_CAPTURE}>
                    <LeadCaptureFormList />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.LEADCAPTUREFORMDETAILS}
                element={
                  <ProtectedRoute moduleName={MODULES.LEAD_CAPTURE}>
                    <LeadCapturedFormLeadList setViewOpenForm={() => {}}/>
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.LEADLIST}
                element={
                  <ProtectedRoute moduleName={MODULES.LEAD_DETAILS}>
                    <LeadList />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.LEADDETAILS}
                element={
                  <ProtectedRoute moduleName={MODULES.LEAD_DETAILS}>
                    <LeadView />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.CREATELEAD}
                element={
                  <ProtectedRoute moduleName={MODULES.LEAD_DETAILS}>
                    <CreateLead />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.LEAD_REPORTS}
                element={
                  <ProtectedRoute moduleName={MODULES.LEAD_REPORTS}>
                    <LeadReports />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.LEADQUALIFICATION}
                element={
                  <ProtectedRoute moduleName={MODULES.LEAD_QUALIFICATION}>
                    <LeadQualification />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.SOCIALIMPORTLEAD}
                element={
                  <ProtectedRoute moduleName={MODULES.LEAD_DETAILS}>
                    <SocialImport />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.UNASSIGNEDLEADS}
                element={
                  <ProtectedRoute moduleName={MODULES.LEAD_ASSIGNMENT}>
                    <UnAssignedLeads />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.ASSIGNMENTRULES}
                element={
                  <ProtectedRoute moduleName={MODULES.LEAD_ASSIGNMENT}>
                    <AssignmentRules />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.ASSIGNMENTRULESLEADS}
                element={
                  <ProtectedRoute moduleName={MODULES.LEAD_DETAILS}>
                    <Leads />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.ASSIGNMENTRULESCREATERULE}
                element={
                  <ProtectedRoute moduleName={MODULES.LEAD_DETAILS}>
                    <CreateAssignmentRule />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.APPROVEDLEADS}
                element={
                  <ProtectedRoute moduleName={MODULES.LEAD_DETAILS}>
                    <ApprovedLeads />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.ARCHIVEDASSIGNMENTRULES}
                element={
                  <ProtectedRoute moduleName={MODULES.LEAD_DETAILS}>
                    <ArchivedRules />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.LEADLOGS}
                element={
                  <ProtectedRoute moduleName={MODULES.LEAD_LOGS}>
                    <LeadLogs />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.ASSIGNEDLEADS}
                element={
                  <ProtectedRoute moduleName={MODULES.ASSIGNED_LEADS}>
                    <LeadLogs />
                  </ProtectedRoute>
                }
              />
              {/* Customer-management routes */}
              <Route
                path={routes.CUSTOMERLIST}
                element={
                  <ProtectedRoute moduleName={MODULES.CUSTOMER_PROFILE}>
                    <CustomerList />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.CUSTOMERDETAILS}
                element={
                  <ProtectedRoute moduleName={MODULES.CUSTOMER_PROFILE}>
                    <CustomerView />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.CUSTOMERENGAGEMENT}
                element={
                  <ProtectedRoute moduleName={MODULES.CUSTOMER_ENGAGEMENT}>
                    <CustomerEngagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.CUSTOMERSUPPORT}
                element={
                  <ProtectedRoute moduleName={MODULES.CUSTOMER_SUPPORT}>
                    <CustomerSupport />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.SOCIALIMPORT_CUSTOMER}
                element={
                  <ProtectedRoute moduleName={MODULES.CUSTOMER_PROFILE}>
                    <CustomerSocialImport />
                  </ProtectedRoute>
                }
              />
              {/* Campaigns routes */}
              <Route
                path={routes.CREATECAMPAIGN}
                element={
                  <ProtectedRoute moduleName={MODULES.CREATE_CAMPAIGNS}>
                    <CreateCampaign />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.CAMPAIGNLIST}
                element={
                  <ProtectedRoute moduleName={MODULES.VIEW_CAMPAIGNS}>
                    <CampaignList />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.CAMPAIGNDETAILS}
                element={
                  <ProtectedRoute moduleName={MODULES.VIEW_CAMPAIGNS}>
                    <CampaignView />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.LANDINGPAGE}
                element={
                  // <ProtectedRoute moduleName={MODULES.LANDING_PAGE}>
                  <CampaignLandingPage />
                  //  </ProtectedRoute>
                }
              />

              {/* Surveys , Email and Letter templates routes */}
              <Route
                path={routes.VIEWSURVEY}
                element={
                  <ProtectedRoute moduleName={MODULES.VIEW_SURVEYS}>
                    <ViewSurveys />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.CREATESURVEY}
                element={
                  <ProtectedRoute moduleName={MODULES.CREATE_SURVEYS}>
                    <CreateSurveys />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.QRCODELIST}
                element={
                  <ProtectedRoute moduleName={MODULES.QR_CODE_LIST}>
                    <QRCodeList />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.UNSUBSCRIBED_USERS}
                element={
                  // <ProtectedRoute moduleName={MODULES.QR_CODE_LIST}>
                  <UnsubscribedUsersList
                    setSelectedUserId={() => {}}
                    setSelectedUserType={() => {}}
                    setSelectedUserName={() => {}}
                    setViewOpen={() => {}}
                    setCrumbMappingOption={() => {}}
                    setIndexValue={() => {}}
                  />
                  // </ProtectedRoute>
                }
              />

              <Route
                path={routes.CAMPAIGN_PERFORMANCE_METRICS}
                element={
                  <ProtectedRoute
                    moduleName={MODULES.CAMPAIGN_PERFORMANCE_METRICS}
                  >
                    <CampaignPerformanceMetrics />
                  </ProtectedRoute>
                }
              />

              <Route
                path={routes.EMAILTEMPLATES}
                element={
                  <ProtectedRoute moduleName={MODULES.EMAIL_TEMPLATES}>
                    <EmailTemplateTabs />
                  </ProtectedRoute>
                }
              />

              <Route
                path={routes.LETTERTEMPLATES}
                element={
                  <ProtectedRoute moduleName={MODULES.LETTER_TEMPLATES}>
                    <LetterTemplatesList />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.GENERAL_NOTES}
                element={
                  <ProtectedRoute moduleName={MODULES.GENERAL_NOTES}>
                    <NotesList />
                  </ProtectedRoute>
                }
              />
              {/* User-management routes */}
              <Route
                path={routes.USER_REQUESTS}
                element={
                  <UserRequests />
                  // <ProtectedRoute moduleName={MODULES.USER_MANAGEMENT}>
                  //   <UserManagementList />
                  // </ProtectedRoute>
                }
              />
              <Route
                path={routes.USER_MANAGEMENT_LIST}
                element={
                  <ProtectedRoute moduleName={MODULES.USER_LISTS}>
                    <UserManagementList />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.USER_MANAGEMENT_ROLE}
                element={
                  <ProtectedRoute
                    moduleName={MODULES.USER_ROLES_AND_PERMISSIONS}
                  >
                    <UserManagementRole />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.USER_MANAGEMENT_TERMSOFSERVICES}
                element={<UserTermsOfService />}
              />
              <Route
                path={routes.USER_REPORTS}
                element={
                  <ProtectedRoute moduleName={MODULES.USER_REPORTS}>
                    <UserReports />
                  </ProtectedRoute>
                }
              />

              {/* Payments */}
              <Route
                path={routes.ORDERSLIST}
                element={
                  <ProtectedRoute moduleName={MODULES.ORDER_MANAGEMENT}>
                    <Orders />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.ORDER_DETAILS_CHANGE_PLAN}
                element={
                  <ProtectedRoute moduleName={MODULES.ORDER_MANAGEMENT}>
                    <OrderDetailChangePlan />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.ORDER_DETAILS}
                element={
                  <ProtectedRoute moduleName={MODULES.ORDER_MANAGEMENT}>
                    <OrderDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path={routes.INVOICELIST}
                element={
                  <ProtectedRoute moduleName={MODULES.ORDER_MANAGEMENT}>
                    <InvoicesList />
                  </ProtectedRoute>
                }
              />

              <Route
                path={routes.SUBSCRIPTIONREPORT}
                element={
                  <ProtectedRoute moduleName={MODULES.SUBSCRIPTION_REPORT}>
                    <SubscriptionReport />
                  </ProtectedRoute>
                }
              />

              <Route
                path={routes.SUPPORT_TICKETS}
                element={
                  <ProtectedRoute moduleName={MODULES.SUPPORT_TICKETS}>
                    <SupportTicketTabs />
                  </ProtectedRoute>
                }
              />
              {/* Footer  */}
              <Route
                path={routes.TERMSOFSERVICES}
                element={<TermsOfService />}
              />
              <Route path={routes.PROFILE} element={<Profile />} />

              {/* My plans routes*/}
              <Route path={routes.MY_PLANS} element={<Myplans />} />
              <Route
                path={routes.USER_CHANGE_PLAN}
                element={<UserChangePlan />}
              />

              <Route
                path={routes.PERSONAL_SETTINGS}
                element={<PersonalSettings />}
              />
              <Route
                path={routes.COMPANYSETTINGS}
                element={<CompnaySettings />}
              />
              <Route path={routes.COMPANY_PROFILE} element={<Profile />} />
              <Route
                path={routes.TRACK_UPLOADS}
                element={
                  <ProtectedRoute moduleName={MODULES.TRACK_UPLOADS}>
                    <TrackUploads />
                  </ProtectedRoute>
                }
              />
              <Route path={routes.GUIDES} element={<Guides />} />
            </Route>
            <Route path={routes.RESETPASSWORD} element={<ResetPassword />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route
              path={routes.UNSUBSCRIBE}
              element={<UnsubscribeConfirmation />}
            />

            <Route
              path="*"
              element={<Navigate to={routes.DASHBOARD} replace />}
            />
          </>
        ) : (
          <>
            <Route path="/no-role" element={<Unauthorized />} />
            <Route
              path={routes.LOGIN}
              element={<Login isLoggedIn={props.isLoggedIn} />}
            />
            <Route path={routes.FORGOTPASSWORD} element={<ForgotPassword />} />
            <Route path={routes.CONTACT_US} element={<ContactUs />} />
            <Route path={routes.REQUEST_ACCESS} element={<RequestAccess />} />
            <Route path={routes.RESETPASSWORD} element={<ResetPassword />} />
            <Route
              path={routes.UNSUBSCRIBE}
              element={<UnsubscribeConfirmation />}
            />

            <Route path="*" element={<Navigate to={routes.LOGIN} replace />} />
          </>
        )}
      </Route>,
    ),
  );
  return <RouterProvider router={router} />;
}

export default connect(
  mstp,
  mdtp
)((props: any) => {
  const { setLoggedIn } = props;
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    // Disable inspect element on preproduction (all common ways)
    const baseUrl = window.location.origin;

    if (process.env.REACT_APP_PRODUCTION_URL === baseUrl) {
      // Disable right-click context menu
      document.addEventListener("contextmenu", (e) => {
        e.preventDefault();
      });

      // Disable F12, Ctrl+Shift+I/J/C/U, Cmd+Opt+I/J/C/U (Mac), Ctrl+Shift+K (Firefox), Ctrl+Shift+C (Inspect), Ctrl+Shift+S (Sources)
      document.addEventListener("keydown", (e) => {
        if (e.key === "F12") {
          e.preventDefault();
          e.stopPropagation();
        }
        if (
          (e.ctrlKey &&
            e.shiftKey &&
            ["I", "J", "C", "K", "S"].includes(e.key)) ||
          (e.ctrlKey && e.key === "U")
        ) {
          e.preventDefault();
          e.stopPropagation();
        }
        if (
          (e.metaKey && e.altKey && ["I", "J", "C", "S"].includes(e.key)) ||
          (e.metaKey && e.key === "U")
        ) {
          e.preventDefault();
          e.stopPropagation();
        }
      });

      // Prevent opening devtools via touch events (long press)
      document.addEventListener("touchstart", (e) => {
        if (e.touches.length > 1) {
          e.preventDefault();
        }
      });

      // Prevent drag events (which can sometimes trigger devtools)
      document.addEventListener("dragstart", (e) => {
        e.preventDefault();
      });

      // Prevent selection (double/triple click)
      document.addEventListener("selectstart", (e) => {
        e.preventDefault();
      });
    }

    setLoading(true);
    const loggedIn = !_.isEmpty(getCurrentUser());
    const userDetails = loggedIn ? getCurrentUser() : "";
    setLoggedIn(loggedIn, userDetails);
    const storedData = localStorage.getItem("loginData");
    if (storedData) {
      const loginData = JSON.parse(storedData);
      const { primaryColor, accentColor } = loginData?.tenantDetails;
      applyCSSVariables(primaryColor, accentColor);
    }
    setLoading(false);
  }, [setLoggedIn]);

  let loggedIn = false;
  try {
    loggedIn = !_.isEmpty(getCurrentUser());
  } catch (e) {
    console.log(e);
  }

  return (
    <AppRoute>
      {loading ? <div>Loading...</div> : <App {...props} loggedIn={loggedIn} />}
    </AppRoute>
  );
});
